module.exports = __webpack_public_path__ + "img/hppc_white_logo.67aa87ca.svg";